import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Home = ({ language, onViewContent }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [contents, setContents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const translations = {
        hero: {
            title: {
                zh: '欢迎使用内容分享平台',
                en: 'Welcome to Content Sharing Platform'
            },
            subtitle: {
                zh: '输入内容代码或搜索关键词，找到您需要的内容',
                en: 'Enter content code or search keywords to find what you need'
            },
            search: {
                zh: '搜索',
                en: 'Search'
            },
            placeholder: {
                zh: '输入内容代码或关键词...',
                en: 'Enter content code or keywords...'
            }
        },
        content: {
            title: {
                zh: '热门内容',
                en: 'Popular Content'
            },
            view: {
                zh: '查看',
                en: 'View'
            },
            noResults: {
                zh: '没有找到相关内容',
                en: 'No content found'
            }
        }
    };

    // 加载内容列表
    useEffect(() => {
        const fetchContents = async () => {
            try {
                setLoading(true);
                const response = await axios.get('/api/controllers/contents.php?action=search');
                setContents(response.data.contents || []);
                setError('');
            } catch (err) {
                setError('加载内容列表失败');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchContents();
    }, []);

    // 处理搜索
    const handleSearch = async (e) => {
        e.preventDefault();
        
        if (!searchTerm.trim()) return;
        
        try {
            setLoading(true);
            const response = await axios.get(`/api/controllers/contents.php?action=search&term=${encodeURIComponent(searchTerm)}`);
            setContents(response.data.contents || []);
            setError('');
        } catch (err) {
            setError('搜索失败');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="home-page">
            {/* 英雄区域 */}
            <section className="hero-section text-center">
                <div className="container">
                    <h1>{translations.hero.title[language]}</h1>
                    <p className="lead">{translations.hero.subtitle[language]}</p>
                    
                    <form className="search-box" onSubmit={handleSearch}>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                placeholder={translations.hero.placeholder[language]}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button className="btn btn-primary" type="submit">
                                <i className="bi bi-search me-2"></i>
                                {translations.hero.search[language]}
                            </button>
                        </div>
                    </form>
                </div>
            </section>
            
            {/* 内容列表 */}
            <section className="content-section py-5">
                <div className="container">
                    <h2 className="mb-4">{translations.content.title[language]}</h2>
                    
                    {error && <div className="alert alert-danger">{error}</div>}
                    
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">加载中...</span>
                            </div>
                        </div>
                    ) : contents.length === 0 ? (
                        <div className="alert alert-info">
                            {translations.content.noResults[language]}
                        </div>
                    ) : (
                        <div className="row">
                            {contents.map(content => (
                                <div className="col-md-4 content-item" key={content.id}>
                                    <div className="card h-100">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start mb-3">
                                                <h5 className="card-title">{content.title}</h5>
                                                <span className="badge bg-primary">{content.custom_code}</span>
                                            </div>
                                            <p className="card-text">
                                                {language === 'zh' 
                                                    ? (content.description_zh || '暂无描述') 
                                                    : (content.description_en || 'No description')}
                                            </p>
                                        </div>
                                        <div className="card-footer bg-white border-top-0">
                                            <button 
                                                className="btn btn-outline-primary w-100"
                                                onClick={() => onViewContent(content.custom_code)}
                                            >
                                                <i className="bi bi-eye me-2"></i>
                                                {translations.content.view[language]}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Home; 